<template>
    <div>
        <!-- User Interface controls -->


        <!-- Main table element -->
            <b-table show-empty empty-text="Please wait while the competencies to load." striped responsive stacked="md" 
                 :items="items" 
                 :fields="fields" 
                  :filter="filter" 
                  :sort-by.sync="sortBy"
				 :sort-desc.sync="sortDesc"
                 @filtered="onFiltered">
				<template v-slot:cell(competency)="row">
                {{ row.item.title }}
                <div v-if="row.item.laboratory == 1"><small class="text-success">This competency can be simulated</small></div>
            </template>
<template v-slot:cell(created_at)="row">
				{{ moment(row.item.created_at).format('MMM DD YYYY') }}
			</template>
<template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
					<b-button v-if="role == 'school' || role == 'instructor'" @click="info(row.item.user.name, row.item.id, $event.target)" class="btn btn-danger">
                        <span class="icon icon-trash"></span>
                    </b-button>
                    <b-button @click="signOff(row.item.id)" class="btn btn-primary">
                        <span class="icon icon-check">
                            Sign-off</span>
                    </b-button>
                </b-button-group>
            </template>
</b-table>
<b-modal ok-title="Delete" cancel-title="Cancel" ok-variant="danger" cancel-variant="primary" id="modalInfo" @hide="resetModal" @ok="deleteAssessment" :title="modalInfo.title">
      <p>{{ modalInfo.content }}</p>
	  <textarea type="text" class="form-control" v-model="reason" rows="5" placeholder="Type your reason here..."></textarea>
    </b-modal>

</div>
</template>

<script>
	const items = [];
	var moment = require('moment');
	export default {
		props: ['competencies', 'surl', 'user_role'],
		data() {
			return {
				items: this.competencies,
				url: this.surl,
				moment: moment,
				role: this.user_role,
				reason: '',
				fields: [{
						key: "user.name",
						label: "Student",
					},
					{
						key: "competency",
						label: "Competency",
					},
					{
						key: "created_at",
						label: "Sent",
					},
					{
						key: "actions",
						label: "Actions"
					}
				],
				filter: null,
				sortBy: "created_at",
				sortDesc: false,
				modalInfo: { title: '', content: '', id: '' },
			};
		},
		computed: {
			sortOptions() {
				// Create an options list from our fields
				return this.fields.filter(f => f.sortable).map(f => {
					return {
						text: f.label,
						value: f.key
					};
				});
			}
		},
		filters: {
			uppercase: function(v) {
				return v.toUpperCase();
			}
		},
		methods: {
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},
			info(preceptor_name, id, button) {
				this.modalInfo.title = `Are you sure you want to delete?`
				this.modalInfo.content = "This Competency for " + preceptor_name + ". They will be notified and provided the reason you enter below."
				this.modalInfo.id = id
				this.$root.$emit('bv::show::modal', 'modalInfo', button)
			},
			resetModal() {
				this.modalInfo.title = ''
				this.modalInfo.content = ''
				this.modalInfo.id = ''
			},
			signOff(id) {
				window.location.href = this.url + id;
			},
			deleteAssessment() {
				axios.post('/school/delete/comp-assessment', {
						competency: this.modalInfo.id,
						reason: this.reason
					})
					.catch(function (error) {
						// handle error
						swal({
						title: "Something went wrong, please contact support!",
						icon: "warning"
						});
					})
					.then(response => this.items = response.data);
				swal({
					title: "Competency Deleted!",
					icon: "success"
				});
				this.modalInfo.title = ''
				this.modalInfo.content = ''
				this.modalInfo.id = ''
				this.reason = ''
			},
		},
	};
</script>

<!-- table-complete-1.vue -->